<div fxLayout="row" fxLayoutAlign="center center">
  <div class="pdf-container">
    <app-pdf-viewer
      pdfUrl="https://documentcloud.adobe.com/view-sdk-demo/PDFs/Bodea Brochure.pdf"
      embedMode="SIZED_CONTAINER">
    </app-pdf-viewer>
  </div>
</div>